module.exports = {
  siteTitle: 'Lemans 1966', // <title>
  manifestName: 'lemans66',
  manifestShortName: 'lemans66', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/lemans66`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Le Mans 66',
  subHeading: 'beez,fzf zfeze ',
  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/anubhavsrivastava',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/onlyanubhav',
    },
    {
      icon: 'fa-facebook',
      name: 'Facebook',
      url: 'https://facebook.com/theanubhav',
    },
  ],
  emailId: 'anubhav.srivastava00@gmail.com',
  phone: '020182389123',
  address: '11 Ashiyana, Mumbai, India',
      produits: [
          {
              titre : 'nom produit 1',
              prix : '19.99€',
              description: 'Le souvenir incontournable de la course des 24 Heures Camions 2019 !',
              lien : 'https://boutique.lemans.org/fr/24-heures-camions/1416-t-shirt-homme-24-heures-camion.html'
          },
           {
              titre : 'nom produit 2',
              prix : '29.99€',
              description: 'Le souvenir incontournable de la course des 24 Heures Camions 2019 !',
              lien : 'https://boutique.lemans.org/fr/24-heures-camions/1416-t-shirt-homme-24-heures-camion.html'
          },
           {
              titre : 'nom produit 1ezdez',
              prix : '199.99€',
              description: 'Le souvenir incontournable de la course des 24 Heures Camions 2019 !',
              lien : 'https://boutique.lemans.org/fr/24-heures-camions/1416-t-shirt-homme-24-heures-camion.html'
          },
           {
              titre : 'nom produit 1dezdz',
              prix : '179.99€',
              description: 'Le souvenir incontournable de la course des 24 Heures Camions 2019 !',
              lien : 'https://boutique.lemans.org/fr/24-heures-camions/1416-t-shirt-homme-24-heures-camion.html'
          },
          
          
      ]
};
